/** Общие типы, используемые несколькими блоками профиля. */

/** Пол должника. Определяет род глаголов и причастий (ТЗ FR-37). */
export type Gender = 'male' | 'female';

/** Шесть падежей русского языка (ТЗ п. 5.2.2). */
export type GrammaticalCase =
  | 'nominative'
  | 'genitive'
  | 'dative'
  | 'accusative'
  | 'instrumental'
  | 'prepositional';

export const GRAMMATICAL_CASES: GrammaticalCase[] = [
  'nominative',
  'genitive',
  'dative',
  'accusative',
  'instrumental',
  'prepositional',
];

/** Дата в виде строки ISO `ГГГГ-ММ-ДД`. Внутри профиля дат-объектов нет. */
export type IsoDate = string;

/**
 * Денежная сумма хранится в копейках целым числом.
 * Вычисления с плавающей точкой над рублями дают расхождение в копейку
 * между текстом заявления и таблицей кредиторов, что блокирует генерацию
 * по правилу FR-27.
 */
export type Kopecks = number;

/**
 * Составной адрес по разбиению формы приказа МЭР № 530.
 * Заполняется вручную либо раскладывается из подсказки DaData (FR-09).
 */
export interface Address {
  /** Готовая строка одной строкой — то, что печатается в документе. */
  full: string;
  postalCode?: string;
  /** Субъект РФ, например «Свердловская обл» */
  region?: string;
  /** Район, например «Белоярский р-н» */
  area?: string;
  /** Город */
  city?: string;
  /** Населённый пункт (посёлок, село, деревня) */
  settlement?: string;
  street?: string;
  house?: string;
  /** Корпус / строение */
  block?: string;
  /** Квартира / помещение */
  flat?: string;
  /** Идентификаторы ФИАС/КЛАДР от DaData — для последующей сверки, в документ не идут. */
  fiasId?: string;
  kladrId?: string;
  /** Источник: ручной ввод или подсказка. Нужен для разбора инцидентов. */
  source?: 'manual' | 'dadata';
  /**
   * Строка `full` правилась вручную и больше не пересобирается из составных
   * полей. Без этого признака правка «как в паспорте» терялась бы при любом
   * изменении части адреса.
   */
  fullManual?: boolean;
}

/** Ссылка на элемент справочника с сохранением наименования на момент выбора. */
export interface DictionaryRef {
  id: string | null;
  /** Наименование, сохранённое в деле. Переживает архивирование записи справочника. */
  name: string;
}

export interface FullName {
  last: string;
  first: string;
  middle?: string;
}
